/**
 * @generated SignedSource<<a16c3090947e6ae3a39798a0e27994eb>>
 * @relayHash 52ed301e4f005d4b36e632a7296990c3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 62a57993d6ab1aaa47ba4974eb21026e8dba6668b0677e0530c29d10149efba1

import type { ConcreteRequest, Mutation } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraNotificationChannelType = "EMAIL" | "IN_PRODUCT" | "MOBILE_PUSH" | "SLACK" | "%future added value";
export type JiraNotificationType = "COMMENT_CREATED" | "COMMENT_DELETED" | "COMMENT_EDITED" | "DAILY_DUE_DATE_NOTIFICATION" | "ISSUE_ASSIGNED" | "ISSUE_CREATED" | "ISSUE_DELETED" | "ISSUE_MOVED" | "ISSUE_UPDATED" | "MENTIONS_COMBINED" | "MISCELLANEOUS_ISSUE_EVENT_COMBINED" | "PROJECT_INVITER_NOTIFICATION" | "WORKLOG_COMBINED" | "%future added value";
export type JiraUpdateProjectNotificationPreferencesInput = {
  preferences: ReadonlyArray<JiraNotificationPreferenceInput>;
  projectId: string;
};
export type JiraNotificationPreferenceInput = {
  channel?: JiraNotificationChannelType | null | undefined;
  channelsEnabled?: ReadonlyArray<JiraNotificationChannelType> | null | undefined;
  isEnabled?: boolean | null | undefined;
  type: JiraNotificationType;
};
export type projectNotificationsConfigRow_updateProjectPreferencesMutation$variables = {
  cloudId: string;
  input: JiraUpdateProjectNotificationPreferencesInput;
};
export type projectNotificationsConfigRow_updateProjectPreferencesMutation$data = {
  readonly jira: {
    readonly updateProjectNotificationPreferences: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly preferences: {
        readonly commentCreated: {
          readonly " $fragmentSpreads": FragmentRefs<"notificationsConfigRow_personalSettingsNotificationsConfigTable_preference">;
        } | null | undefined;
        readonly commentDeleted: {
          readonly " $fragmentSpreads": FragmentRefs<"notificationsConfigRow_personalSettingsNotificationsConfigTable_preference">;
        } | null | undefined;
        readonly commentEdited: {
          readonly " $fragmentSpreads": FragmentRefs<"notificationsConfigRow_personalSettingsNotificationsConfigTable_preference">;
        } | null | undefined;
        readonly issueAssigned: {
          readonly " $fragmentSpreads": FragmentRefs<"notificationsConfigRow_personalSettingsNotificationsConfigTable_preference">;
        } | null | undefined;
        readonly issueDeleted: {
          readonly " $fragmentSpreads": FragmentRefs<"notificationsConfigRow_personalSettingsNotificationsConfigTable_preference">;
        } | null | undefined;
        readonly issueUpdated: {
          readonly " $fragmentSpreads": FragmentRefs<"notificationsConfigRow_personalSettingsNotificationsConfigTable_preference">;
        } | null | undefined;
        readonly " $fragmentSpreads": FragmentRefs<"notificationsConfigRow_personalSettingsNotificationsConfigTable_allPreferences">;
      } | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type projectNotificationsConfigRow_updateProjectPreferencesMutation = {
  response: projectNotificationsConfigRow_updateProjectPreferencesMutation$data;
  variables: projectNotificationsConfigRow_updateProjectPreferencesMutation$variables;
};
({
  "__relay_internal__pv__atlassianjirarelayprovidersrcincludemiscellaneouseventscombinedtyperelayprovider": includeMiscellaneousCombinedType_provider
} as {
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcincludemiscellaneouseventscombinedtyperelayprovider: {
    readonly get: () => boolean;
  };
});

import includeMiscellaneousCombinedType_provider from '@atlassian/jira-relay-provider/src/include-miscellaneous-events-combined-type.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "success"
},
v4 = {
  "concreteType": "MutationError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "message"
    }
  ]
},
v5 = [
  {
    "kind": "FragmentSpread",
    "name": "notificationsConfigRow_personalSettingsNotificationsConfigTable_preference"
  }
],
v6 = [
  {
    "kind": "ScalarField",
    "name": "channel"
  },
  {
    "kind": "ScalarField",
    "name": "isEnabled"
  },
  {
    "kind": "ScalarField",
    "name": "isEditable"
  }
],
v7 = [
  {
    "kind": "ScalarField",
    "name": "id"
  },
  {
    "kind": "ScalarField",
    "name": "type"
  },
  {
    "concreteType": "JiraNotificationChannel",
    "kind": "LinkedField",
    "name": "emailChannel",
    "plural": false,
    "selections": (v6/*: any*/)
  },
  {
    "concreteType": "JiraNotificationChannel",
    "kind": "LinkedField",
    "name": "inProductChannel",
    "plural": false,
    "selections": (v6/*: any*/)
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "projectNotificationsConfigRow_updateProjectPreferencesMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "concreteType": "JiraUpdateProjectNotificationPreferencesPayload",
            "kind": "LinkedField",
            "name": "updateProjectNotificationPreferences",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "concreteType": "JiraNotificationPreferences",
                "kind": "LinkedField",
                "name": "preferences",
                "plural": false,
                "selections": [
                  {
                    "kind": "FragmentSpread",
                    "name": "notificationsConfigRow_personalSettingsNotificationsConfigTable_allPreferences"
                  },
                  {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "issueAssigned",
                    "plural": false,
                    "selections": (v5/*: any*/)
                  },
                  {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "issueUpdated",
                    "plural": false,
                    "selections": (v5/*: any*/)
                  },
                  {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "issueDeleted",
                    "plural": false,
                    "selections": (v5/*: any*/)
                  },
                  {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "commentCreated",
                    "plural": false,
                    "selections": (v5/*: any*/)
                  },
                  {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "commentEdited",
                    "plural": false,
                    "selections": (v5/*: any*/)
                  },
                  {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "commentDeleted",
                    "plural": false,
                    "selections": (v5/*: any*/)
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcincludemiscellaneouseventscombinedtyperelayprovider"
      }
    ],
    "kind": "Operation",
    "name": "projectNotificationsConfigRow_updateProjectPreferencesMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "concreteType": "JiraUpdateProjectNotificationPreferencesPayload",
            "kind": "LinkedField",
            "name": "updateProjectNotificationPreferences",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "concreteType": "JiraNotificationPreferences",
                "kind": "LinkedField",
                "name": "preferences",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "issueAssigned",
                    "plural": false,
                    "selections": (v7/*: any*/)
                  },
                  {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "issueUpdated",
                    "plural": false,
                    "selections": (v7/*: any*/)
                  },
                  {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "issueDeleted",
                    "plural": false,
                    "selections": (v7/*: any*/)
                  },
                  {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "commentCreated",
                    "plural": false,
                    "selections": (v7/*: any*/)
                  },
                  {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "commentEdited",
                    "plural": false,
                    "selections": (v7/*: any*/)
                  },
                  {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "commentDeleted",
                    "plural": false,
                    "selections": (v7/*: any*/)
                  },
                  {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "issueCreated",
                    "plural": false,
                    "selections": (v7/*: any*/)
                  },
                  {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "issueMoved",
                    "plural": false,
                    "selections": (v7/*: any*/)
                  },
                  {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "mentionsCombined",
                    "plural": false,
                    "selections": (v7/*: any*/)
                  },
                  {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "worklogCombined",
                    "plural": false,
                    "selections": (v7/*: any*/)
                  },
                  {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcincludemiscellaneouseventscombinedtyperelayprovider",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "concreteType": "JiraNotificationPreference",
                        "kind": "LinkedField",
                        "name": "miscellaneousIssueEventCombined",
                        "plural": false,
                        "selections": (v7/*: any*/)
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "62a57993d6ab1aaa47ba4974eb21026e8dba6668b0677e0530c29d10149efba1",
    "metadata": {},
    "name": "projectNotificationsConfigRow_updateProjectPreferencesMutation",
    "operationKind": "mutation",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcincludemiscellaneouseventscombinedtyperelayprovider": includeMiscellaneousCombinedType_provider
    }
  }
};
})();

(node as any).hash = "c6d1b008957d0d915fa6547117558a1a";

export default node;
